/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').
factory('ReadOnlyBookingServiceView',["ActivityData","Period","HumanResourceData",
        function (ActivityData,Period,HumanResourceData){

    var  ReadOnlyBookingServiceView = function (bookingService,bsIndex,bookingView)
    {
        //bookingService : model object
        //bsIndex : index inside booking
        //bookingView : bookingView parent
        this.actIndex=ActivityData.getIndexOf(bookingService);
        this.bsIndex = bsIndex; //model index on booking
        this.bookingView = bookingView;
        this.serviceView = null;
        this.price = 0;
        this.billPosition =bsIndex+1;//position inside booking ->
        this.label = null;
        this.period = null;//period of activity
        this.hrView = null;//special direct access to hrView without need to implement DayHr
        this.hrRequest = false;
        this.loadDataFrom(bookingService);
    }

    ReadOnlyBookingServiceView.prototype.loadDataFrom = function(bookingService)
    {
        //Manage specifics fields of BookingServiceView
        this.price = bookingService.price;
        this.label = bookingService.label;
        this.isPackage = bookingService.isPackage;
        this.hrRequest = bookingService.hrRequest;
        if (bookingService.period)
            this.period = new Period(bookingService.period);
        else
            this.period = null;
        if (this.bookingView && this.bookingView.customerView && this.bookingView.customerView.domainView)
        {
            if (bookingService.service && this.bookingView && this.bookingView.customerView && this.bookingView.customerView.domainView && this.bookingView.customerView.domainView.getServiceView!==undefined)
                this.serviceView =  this.bookingView.customerView.domainView.getServiceView(bookingService.service);
            if (bookingService.dayHr && this.bookingView && this.bookingView.customerView && this.bookingView.customerView.domainView && this.bookingView.customerView.domainView.getHrView!==undefined)
                this.hrView = this.bookingView.customerView.domainView.getHrView(HumanResourceData.getById(bookingService.dayHr.humanResourceId));
        }


    };

    ReadOnlyBookingServiceView.prototype.getModel = function()
    {
        if (this.actIndex!=-1)
            return ActivityData.getByIndex(this.actIndex);
        return null;
    };
    return ReadOnlyBookingServiceView;
}])


// WEBPACK FOOTER //
// ./js/services/views/ReadOnlyBookingServiceView.js